import { forwardRef, useImperativeHandle, useState } from 'react';

import { Box, CircularProgress, Grid, Typography } from '@mui/material';

import { Center } from 'components/Common/Centered';

import { AddImagePopUp } from './AddImagePopUp';
import { ImageCard } from './ImageCard';
import { useImages } from '../../../contexts/ImagesContext';

export class FAQsImage {
  path: string;
  originalFileName: string;
  user: string;
  sizelnBytes: number;
  lastModified: Date;
  contentType: string;
}

export interface ImagesDashboardRef {
  openAddImagePopup: () => void;
}

export const ImagesDashboard = forwardRef<ImagesDashboardRef>((props, ref) => {
  const [isAddImagePopupOpen, setIsAddImagePopupOpen] = useState(false);
  const { isLoading, sortedImages, refetchImages } = useImages();

  useImperativeHandle(ref, () => ({
    openAddImagePopup: () => {
      setIsAddImagePopupOpen(true);
    },
  }));

  return (
    <div>
      <Box height="75vh" mt={5}>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: 'calc(100vh - 200px)',
              width: '100%',
            }}
          >
            <CircularProgress />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Loading Images...
            </Typography>
          </Box>
        ) : sortedImages?.length === 0 ? (
          <Center minHeight="400px">
            <Typography variant="body1" color="grey.500">
              No Image Found!
            </Typography>
          </Center>
        ) : (
          <Grid container spacing={2}>
            {sortedImages?.map((imageItem, key) => (
              <Grid item key={key} xs={12} sm={6} md={3}>
                <ImageCard image={imageItem} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      <AddImagePopUp
        isOpen={isAddImagePopupOpen}
        close={() => setIsAddImagePopupOpen(false)}
        onSuccess={() => refetchImages()}
      />
    </div>
  );
});
